module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dayweek"
  }, _vm._l((_vm.days), function(day, index) {
    return _c('div', {
      key: index,
      staticClass: "dayweek__item"
    }, [_vm._v(_vm._s(day))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da15f3f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/calendarheader/CalendarHeader.vue
// module id = 174b47d488bcf884cf6c
// module chunks = 7